module.exports = __webpack_public_path__ + "img/94.f0e6d444.jpg";